import React, { useState, useEffect } from "react";
import NewLogo from "../../assests/images/collab_ai_logo_white.svg";
import "./IndustryLanding.css";
import { fetchAssistantsCreatedBySuperAdmin } from "../../api/assistant";
import { getCompId, getUserID, getUserRole } from "../../Utility/service";
import { axiosOpen, axiosSecureInstance } from "../../api/axios";
import { USER_COMPANY_DATA_API_SLUG } from "../../constants/Api_constants";
import { useNavigate } from "react-router-dom";
import { Spin, message } from "antd";
import { handleUseAgent } from "../../Utility/personalizeAgentHandler";
const role = getUserRole();

const IndustryLanding = () => {
  const [loading, setLoading] = useState(true);
  const [userIndustry, setUserIndustry] = useState("");
  const [userName, setUserName] = useState("");
  const userId = getUserID();
  const [page] = useState(1);

  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("theme", "dark");
  }, []);

  useEffect(() => {
    const markIndustryLandingSeen = async () => {
      const orgId = getCompId();
      if (!orgId) return;

      try {
        await axiosSecureInstance.patch(`/api/organizations/industry-landing-seen/${orgId}`);
      } catch (error) {
        console.error("Failed to update industry landing flag:", error);
      }
    };

    markIndustryLandingSeen();
  }, []);

  useEffect(() => {
    const fetchUserIndustry = async () => {
      try {
        const userResponse = await axiosOpen.get(USER_COMPANY_DATA_API_SLUG(userId));
        const userData = userResponse?.data;
        setUserIndustry(userData?.industry);
        setUserName(userData?.name);
      } catch (error) {
        console.error("Failed to fetch user industry:", error);
      }
    };

    if (userId) {
      fetchUserIndustry();
    }
  }, [userId]);

  useEffect(() => {
    if (!userId || !userIndustry) return;

    const fetchAndCloneAgents = async () => {
      setLoading(true);
      try {
        const industries = Array.isArray(userIndustry)
          ? userIndustry
          : typeof userIndustry === "string"
            ? [userIndustry]
            : [];

        const response = await fetchAssistantsCreatedBySuperAdmin(page, 10, industries.join(","));

        if (response?.data && response.data.length > 0) {
          const assistantIds = response.data.map((agent) => agent.assistant_id);
          await handleUseAgent(assistantIds, navigate, setLoading);
          // Delay message until animation completes (4 seconds)
          setTimeout(() => {
            message.success("Personalized Agents created successfully!");
          }, 4000);
        } else {
          // Delay message until animation completes
          if (role === "admin") {
            navigate("/allAssistantsList", { replace: true });
          } else if (role === "superadmin") {
            navigate("/agentsList", {replace: true });
          }
          setTimeout(() => {
            message.warning("No assistants available to clone.");
          }, 4000);
        }
      } catch (error) {
        console.error("Failed to fetch or clone agents:", error);
        // Delay message until animation completes
        setTimeout(() => {
          message.error("Failed to clone assistants.");
        }, 4000);
      } finally {
        setLoading(false);
      }
    };

    fetchAndCloneAgents();
  }, [userId, userIndustry, page, navigate]);

  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      <div className="industry-landing">
        <div className="industry-landing-logo">
          <img src={NewLogo} alt="Collab AI Logo" />
        </div>

        <h1 className="welcome-h1">
          Welcome to CollabAI
          {userName ? `, ${userName.charAt(0).toUpperCase() + userName.slice(1)}` : ""}
        </h1>

        <p className="industry-landing-subtitle">
          Based on your Industry ({userIndustry || "Loading..."}) we're preparing some powerful agents for you
        </p>

        <div className="industry-landing-spinner">
          <Spin size="large" />
          <p className="loading-text">
            Please be patient as we create some powerful agents for you. This process may take a little time
          </p>
        </div>
      </div>
    </div>
  );
};

export default IndustryLanding;